import React from 'react';

const Loader = () => {
  return (
    <div className="relative flex min-h-[60vh] items-center justify-center overflow-hidden bg-surface">
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -left-24 top-10 h-72 w-72 rounded-full bg-blue-500/10 blur-3xl" />
        <div className="absolute -right-24 bottom-10 h-80 w-80 rounded-full bg-fuchsia-500/10 blur-3xl" />
      </div>
      <div className="relative flex flex-col items-center gap-4 rounded-3xl border border-white/10 bg-slate-950/70 px-8 py-7 shadow-2xl shadow-black/30 backdrop-blur-xl">
        <div className="relative flex h-14 w-14 items-center justify-center rounded-full border border-blue-400/20 bg-blue-500/10">
          <div className="absolute inset-0 rounded-full border-2 border-blue-400/40 animate-ping opacity-40" />
          <div className="h-10 w-10 rounded-full border-4 border-blue-400 border-t-transparent animate-spin" />
        </div>
        <div className="text-center">
          <p className="text-sm font-semibold uppercase tracking-[0.28em] text-slate-400">Loading</p>
          <p className="mt-1 text-sm text-slate-300">Please wait while we prepare the page.</p>
        </div>
      </div>
    </div>
  );
};

export default Loader;
